import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

export const useLoginOTP = () => {
  const { authHeader } = useAuth();

  return useMutation((code: number) => {
    return axios.post(
      `${env.verifyServiceUrl}user/two_factor/login/${code}/`,
      {},
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
